import { HttpInjector } from '@/cowboy/http/HttpInjector'
import { RedemptionHistoryResponse } from '@/cowboy/redemption/object/RedemptionHistoryResponse'

export class RedemptionApi extends HttpInjector {
  /**
   * Fetch redemption history for the current RewardLink
   * @return {Promise<Array<RedemptionHistoryResponse>>}
   */
  static async fetchRedemptionHistory (count, after) {
    const params = {
      code: this.codeVersion.requestCode,
      version: this.codeVersion.urlVersion,
      count
    }
    if (after) {
      params.after = after
    }
    const response = await this.$http.get('/redemption-history', { params })
    return this.cast(response.data, RedemptionHistoryResponse)
  }

  /**
   * Resend reward for the given reference line item id
   * @param {string} referenceLineItemId
   * @return {Promise<void>}
   */
  static async resendReward (referenceLineItemId) {
    const payload = {
      encryptedStoredValue: {
        encryptedRequestCode: this.codeVersion.requestCode,
        urlVersion: this.codeVersion.urlVersion
      },
      referenceLineItemId
    }
    await this.$http.post('order-history/resends', payload)
  }
}
